export default "__VITE_PUBLIC_ASSET__aee258d2__"